import { render, staticRenderFns } from "./expert-problem.vue?vue&type=template&id=0e934bc7&scoped=true"
import script from "./expert-problem.vue?vue&type=script&lang=js"
export * from "./expert-problem.vue?vue&type=script&lang=js"
import style0 from "./expert-problem.vue?vue&type=style&index=0&id=0e934bc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e934bc7",
  null
  
)

export default component.exports